import { render, staticRenderFns } from "./FieldDegree.vue?vue&type=template&id=783b8b54&"
import script from "./FieldDegree.vue?vue&type=script&lang=js&"
export * from "./FieldDegree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports